var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('materials-scanner',{ref:"materialsScanner",on:{"screen-closed":() => _vm.$emit('closed')}}),_c('modal-confirm',{ref:"confirm",attrs:{"max-width":"900px"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }